import { render, staticRenderFns } from "./BonusSendTablePane.vue?vue&type=template&id=a22dd6a6&scoped=true"
import script from "./BonusSendTablePane.vue?vue&type=script&lang=js"
export * from "./BonusSendTablePane.vue?vue&type=script&lang=js"
import style0 from "./BonusSendTablePane.vue?vue&type=style&index=0&id=a22dd6a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22dd6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a22dd6a6')) {
      api.createRecord('a22dd6a6', component.options)
    } else {
      api.reload('a22dd6a6', component.options)
    }
    module.hot.accept("./BonusSendTablePane.vue?vue&type=template&id=a22dd6a6&scoped=true", function () {
      api.rerender('a22dd6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/BonusSend/BonusSendTablePane.vue"
export default component.exports